import { Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService, VariablesService, AuthService, StorageService } from 'src/app/shared/services';
import { HealthFirstService } from '../../services/health-first.service';
import { environment } from 'src/environments/environment';
import { NgxGlideModule } from 'ngx-glide';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hf-thankyou-page',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  templateUrl: './hf-thankyou-page.component.html',
  styleUrls: ['./hf-thankyou-page.component.scss']
})
export class HfThankyouPageComponent {
  constructor(
    public util: UtilService,
    private actRoute: ActivatedRoute,
    private hfService: HealthFirstService,
    public vars: VariablesService,
    private router: Router,
    private authService: AuthService,
    private storage: StorageService
  ) {}
  contentInfo = {
    headerContent: {
      title: 'Congratulations ',
      subTitle: 'your HealthFirst',
      highlighted: 'Active Now',
      desc: 'Make the most of your plan – a lot of good is waiting for you! Here’s how to access your benefits'
    },
    sliderContent: [
      { id: 1, title: 'Download the <span>Medibuddy</span> App.', desc: 'Get the app for free to access your plan benefits!' },
      { id: 2, title: 'Login to the App', desc: 'Use your registered phone number to login to the MediBuddy App'},
      { id: 3, title: 'Click on ‘Profile’', desc: 'You’ll find the profile section on the top left of your screen.'},
      { id: 4, title: 'Switch to ‘Ketto Benefits’', desc: 'Switch from ‘My MediBuddy benefits’ to ‘Ketto Benefits’ in the drop-down menu'},
      { id: 5, title: 'You’re in!', desc: 'Start exploring the many benefits that are part of the plan you chose!'},
    ]
  }

  policyDatas;
  selectedPlan;
  qparamDatas;
  userData;
  @Input() userdata;
  plansName = '';

  ngOnInit() {
    this.getQParams();
    this.checkHfData();
    this.checkUser();
  }

  checkUser() {
    this.userData = this.storage.get('userdata');
    if (this.userData && this.router.url !== '/healthfirst/calculator') {
      this.userRedirection();
    } else {
      this.router.navigate(['/healthfirst']);
    }
  }

  userRedirection() {
    if (this.actRoute.snapshot.queryParams['plan']) {
      this.plansName = this.actRoute.snapshot.queryParams['plan'];
    } else if (this.userData?.last_health_first_order?.order_plan?.plan_id) {
      this.plansName = this.vars.medibuddyPlanName[this.userData.last_health_first_order.order_plan.plan_id];
    } else if (this.userData?.userHealthPolicy) {
      this.plansName = this.vars.medibuddyPlanName[+this.userData.data?.userHealthPolicy?.planId];
    }
    // redirection logic 
    if (this.userData) {
      // if user exists
      // both last healthfirst order and userHealthPolicy is null
      if (this.userData && this.userData.last_health_first_order === null && this.userData.userHealthPolicy === null) {
        this.router.navigate(['/healthfirst']);
        // if only User healthpolicy is null
      } else if(this.userData.last_health_first_order !== null && this.userData.userHealthPolicy === null) {
        // stays on thankyou page
        this.contentInfo.headerContent.title = 'Congratulations ' + this.userData.full_name + '!';
        // if last healthfirst order is not null and user healthpolicy is not null
      } else if (this.userData && this.userData.last_health_first_order !== null &&
        this.userData.userHealthPolicy !== null) {
          // if order id of las healthfirst order and user healthpolicy is same 
          // but user healthpolicy status is not 1
          if(this.userData.last_health_first_order.order_id === this.userData.userHealthPolicy.orderId && 
            this.userData.userHealthPolicy.status !== 1) {
              // go to healthfirst
              this.router.navigate(['/healthfirst']);
          // if isMedibuddy is false but order id is same from last healthfirst order and user healthfirstpolicy
          } else if (!this.userData.is_medibuddy && 
          this.userData.last_health_first_order.order_id === this.userData.userHealthPolicy.orderId) {
            // BIMA PLAN
          window.location.href = environment.sipretention_domain + '/healthfirst';
          // sip redirect
          // if is medibuddy is false and order id doesnot match
        } else if (!this.userData.is_medibuddy &&
          this.userData.last_health_first_order.order_id !== this.userData.userHealthPolicy.orderId) {
            // user stays on thankyou page
            this.contentInfo.headerContent.title = 'Congratulations ' + this.userData.full_name + '!';;
          // if ismedibuddy is true 
        } else if (this.userData.is_medibuddy) {
          // user stays on thankyou page
          this.contentInfo.headerContent.title = 'Congratulations ' + this.userData.full_name + '!';
        }
      } else if (this.userData.is_medibuddy) { 
        this.contentInfo.headerContent.title = 'Congratulations ' + this.userData.full_name + '!';
      } else {
        // else redirect to healthfirst
        this.router.navigate(['/healthfirst']);
      }
      // if not logged in go to signin page
    } else {
      this.router.navigate(['/new/signin'], {queryParams: {redirect_uri: '/healthfirst/thankyou', vendor: 'medibuddy', loginType: 'thankyou'}});
    }
  }


  planDetailsHandler() {
    this.hfService.getHFPolicyDetails().subscribe(data => {
      if (!data.data || data.data === null) {
        this.router.navigate(['/healthfirst']);
      } else {
        // stays in this page
        this.contentInfo.headerContent.title += this.userData.full_name + '!';
      }
    });
  }
  
  setInfoData(data) {
    const { policies } = data.data.healthfirst;
    this.selectedPlan = policies.plans[this.qparamDatas.plan];
  }

  getHealthPlans() {
    this.hfService.getHealthFirstData().subscribe(data => {
      if (data) {
        this.vars.hfDashboardData = data;
        this.setInfoData(data);
      }
    })
  }

  checkHfData() {
    if (this.vars.hfDashboardData && Object.keys(this.vars.hfDashboardData).length > 0) {
      this.setInfoData(this.vars.hfDashboardData);
    } else {
      this.getHealthPlans();
    }
  }

  getQParams() {
    const {person, cover_amount, cover, oi, plan } = this.actRoute.snapshot.queryParams;
    this.qparamDatas = {
      person, 
      cover,
      cover_amount,
      oi,
      plan
    }
  }
}
